import { useMediaQuery } from 'usehooks-ts';

export const useScreenSize = () => {
	const isSmallScreen = useMediaQuery('(max-width: 639px)');

	return {
		isSmallScreen
	};
};
